var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { RequestClient } from "../basics/request-client.service";
import { autoinject } from "aurelia-framework";
import { Api } from "../../constants/modules/api.constants";
import { TokenClient } from "../authentication/token-client.service";
import * as Enumerable from "linq";
import { toNative } from "../../utilities/promise-utils";
var SweepstakeClientService = /** @class */ (function () {
    function SweepstakeClientService(requestClient, tokenClient) {
        this.requestClient = requestClient;
        this.tokenClient = tokenClient;
    }
    SweepstakeClientService.prototype.getSweepstakeForAdmin = function (request) {
        return toNative(this.requestClient.get(Api.ManageSweepstakes.GetForAdmin, request));
    };
    SweepstakeClientService.prototype.save = function (request) {
        return toNative(this.requestClient.post(Api.ManageSweepstakes.Save, {}, request));
    };
    SweepstakeClientService.prototype.delete = function (request) {
        return toNative(this.requestClient.post(Api.ManageSweepstakes.Delete, {}, request));
    };
    SweepstakeClientService.prototype.getSweepstakes = function () {
        return toNative(this.requestClient.get(Api.ManageSweepstakes.GetAll, {}));
    };
    SweepstakeClientService.prototype.getSweepstakesByBrand = function (brandId, getAll) {
        var _this = this;
        if (brandId === void 0) { brandId = null; }
        if (getAll === void 0) { getAll = false; }
        if (getAll || (this.tokenClient.isPreview && !this.tokenClient.user.brandId)) {
            // super admin preview: return all as BrandSweepstakeModel[]
            return new Promise(function (resolve, reject) {
                _this.getSweepstakes().then(function (sweepstakes) {
                    var list = Enumerable.from(sweepstakes)
                        .select(function (sweepstake) {
                        var sweepstakeModel = {
                            sweepstakeId: sweepstake.sweepstakeId,
                            sweepstake: sweepstake
                        };
                        return sweepstakeModel;
                    })
                        .toArray();
                    resolve(list);
                }, reject);
            });
        }
        if (this.tokenClient.isPreview && this.tokenClient.user.brandId) {
            return toNative(this.requestClient.get(Api.ManageSweepstakes.GetSweepstakesByBrand, { brandId: this.tokenClient.user.brandId }));
        }
        return toNative(this.requestClient.get(Api.ManageSweepstakes.GetSweepstakesByBrand, { brandId: brandId }));
    };
    SweepstakeClientService.prototype.createNewDraw = function (request) {
        return toNative(this.requestClient.post(Api.ManageSweepstakes.CreateNewDraw, {}, request));
    };
    SweepstakeClientService = __decorate([
        autoinject(),
        __metadata("design:paramtypes", [RequestClient, TokenClient])
    ], SweepstakeClientService);
    return SweepstakeClientService;
}());
export { SweepstakeClientService };
